import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandler } from '@app/shared/services/http-error-handler.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ISpringResponseBody, observeTypes } from '@app/shared/interfaces/response-interfaces';
import { AppConfig } from '@app/config/app.config';
import { catchError, map } from 'rxjs/operators';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { LoggerService } from '@app/shared/services/logger.service';
import { SigningHistoryRequest, OrderHistoryRequest, RequestedHistoryRequest, RequestedHistoryDetailsRequest } from './history';
import { SessionStorageService } from '@app/core';


@Injectable()
export class HistoryService {
  private handleError: HandleError;
  private headerHelper: any;

  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private http: HttpClient,
    private store: Store<any>,
    private logger: LoggerService,
    private sessionStorageService: SessionStorageService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HistoryService');
    this.headerHelper = new HeadersSetterHelper(this.store);
  }

  getSigningHistory(displayOptions: SigningHistoryRequest, isBusinessMode?: boolean): Observable<ISpringResponseBody | any> {
    return this.http.get<ISpringResponseBody>(
      isBusinessMode ? AppConfig.endpoints.history.businessSigning : AppConfig.endpoints.history.signing,
      this.buildRequestOptions(displayOptions)
    ).pipe(
      catchError(this.handleError('getSigningHistory')),
    );
  }

  getRequestsHistory(displayOptions: SigningHistoryRequest, isBusinessMode?: boolean): Observable<ISpringResponseBody | any> {
    return this.http.get<ISpringResponseBody>(
      isBusinessMode ? AppConfig.endpoints.history.businessRequested : AppConfig.endpoints.history.requested,
      this.buildRequestOptions(displayOptions)
    ).pipe(
      catchError(this.handleError('getRequestsHistory')),
    );
  }

  getRequestsHistoryDetails(displayOptions: RequestedHistoryDetailsRequest): Observable<ISpringResponseBody | any> {
    return this.http.get<ISpringResponseBody>(
      AppConfig.endpoints.history.requestedDetails,
      this.buildRequestOptions(displayOptions)
    ).pipe(
      catchError(this.handleError('getRequestsHistory')),
    );
  }

  buildRequestOptions(displayOptions: SigningHistoryRequest) {
    let params = new HttpParams();
    // setting request options
    Object.keys(displayOptions).forEach((key) => {
      if (key === 'textToShow') {
        params = params.set(key, encodeURIComponent(displayOptions[key]));
      } else {
        params = params.set(key, displayOptions[key]);
      }
    });
    return this.headerHelper.historyOptions(observeTypes.BODY, params);
  }

  getOrdersHistory(displayOptions: OrderHistoryRequest): Observable<ISpringResponseBody | any> {
    return this.http.get<ISpringResponseBody>(
      AppConfig.endpoints.history.orders,
      this.buildOrderHistoryRequestOptions(displayOptions)
    ).pipe(
      catchError(this.handleError('getOrdersHistory')),
      map((res: ISpringResponseBody) => {
        this.logger.log(res);
        return res;
      }));
  }

  buildOrderHistoryRequestOptions(displayOptions: OrderHistoryRequest) {
    let params = new HttpParams();
    // setting request options

    Object.keys(displayOptions).forEach(key => {

      if (displayOptions[key] !== undefined && displayOptions[key] !== '') {
        params = params.set(key, displayOptions[key]);
      }

    });
    const options = this.headerHelper.historyOptions(observeTypes.BODY, params);
    console.log(options);
    return options;
  }

  // CANCELED: -1,
  //   IN_PROGRESS: 1,
  //   PAID: 2,
  //   NEW: 0

  getOrderStatusNumber(value) {
    switch (value) {
      case 'PAID':
        return 2;
      case 'CANCELED':
        return -1;
      case 'ORDERED':
        return 1;
      case 'NEW':
        return 0;
    }
  }

  getRequestedHistory(displayOptions: RequestedHistoryRequest): Observable<ISpringResponseBody | any> {
    return this.http.get<ISpringResponseBody>(
      AppConfig.endpoints.history.requested,
      this.buildRequestedHistoryOptions(displayOptions)
    ).pipe(
      catchError(this.handleError('getRequestedHistory')),
    );
  }

  buildRequestedHistoryOptions(displayOptions: RequestedHistoryRequest) {
    let params = new HttpParams();
    // setting request options
    Object.keys(displayOptions).forEach((key) => {
      if (key === 'textToShow') {
        params = params.set(key, encodeURIComponent(displayOptions[key]));
      } else {
        params = params.set(key, displayOptions[key]);
      }
    });
    return this.headerHelper.historyOptions(observeTypes.BODY, params);
  }

  checkForBusinessAccount() {
    return this.sessionStorageService.getItem("businessAccountId") && this.sessionStorageService.getItem("businessAccountId")!='personal';
  }

}
